import { useRouter } from 'next/router';

export const useTableNumFromQuery = () => {
  const {
    query: { tableNum, tableNumber, tableId },
  } = useRouter();

  return tableNum || tableNumber || tableId || '';
};
